import { SolutionOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import MazakaCard from "apps/Common/MazakaCart";
import { useState } from "react";
import ConfirmPayment from "./ConfirmPayment";
import CardInfoes from "./CardInfoes";
import PackageInfoes from "./PackageInfoes";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import SuccessPayment from "./SuccessPayment"; // ✅ başarı modalı
import { useSearchParams } from "react-router-dom";
import { patchAdvert, editAdvert } from "../../Services";
import { Helmet } from "react-helmet-async";

const Payment = (props: any) => {
  const [isShowConfirmPaymentModal, setisShowConfirmPaymentModal] =
    useState(false);
  const [isShowSuccessPaymentModal, setIsShowSuccessPaymentModal] =
    useState(false); // ✅ başarı modal state

  const { selectedPackages } = useSelector((state: RootState) => state.ad);
  const { adData, adType } = useSelector((state: RootState) => state.ad);
  console.log("selectedPackages", selectedPackages);
  const dopingList =
    selectedPackages?.dopings?.map((item: any) => item.id) || [];
  console.log("dopingList", dopingList);
  console.log("adData", adData)
  const isPaid =
    (selectedPackages?.package?.price &&
      Number(selectedPackages.package.price) > 0) || dopingList.length > 0;

  //Sadece başarı modalı açılır
  const [searchParams, setSearchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const handleCompleteFreeAd = async () => {
    try {
      let response: any = null;
      console.log("adData", adData);

      if (advertId) {
        // adData'yı status: 1 ve isCompleted: true ile güncelle
        const updatedAdData = {
          ...adData,
          isCompleted: true
        };

        response = await editAdvert(updatedAdData);
        console.log("Edit response:", response);
      }

      setIsShowSuccessPaymentModal(true);
    } catch (error) {
      console.error("İlan güncellenirken hata oluştu:", error);
      // Hata durumunda kullanıcıya bilgi verilebilir
    }
  };
  // const handleCompleteFreeAd = async () => {
  //   // let patchDataList: any[] = [];
  //   // let obj = {
  //   //       op: "replace",
  //   //       path: "status" ,
  //   //       value: 1,
  //   //     };
  //   //     patchDataList.push(obj);
  //   //     const data: any = { id: advertId, patch: patchDataList };
  //   //       await patchAdvert(data);
  //    let response: any = null;
  //    console.log("adData",adData)
  //    if (advertId) {

  //         // await editAdvert({ ...adData,  });
  //       }

  //   setIsShowSuccessPaymentModal(true);
  // };

  return (
    <>
      <Col span={24} className="!mt-8 !overflow-hidden">
      <Helmet>
          <title className="capitalize">{"Ödeme"}</title>
        </Helmet>
        <Row className={`${isPaid ? "" : "justify-center"}`}>
          {isPaid ? (
            <MazakaCard
              xs={24}
              lg={10}
              xxl={12}
              className="!bg-[#f9f9f9]  !h-screen !rounded-tl-sm !rounded-tr-none !rounded-bl-sm !rounded-br-none !overflow-hidden xl:!px-16"
            >
              <CardInfoes />
            </MazakaCard>
          ) : (

            <MazakaButton
              className="!p-4 !w-[70%] !bg-[#FFC502] !text-black"
              block
              icon={<SolutionOutlined />}
              onClick={handleCompleteFreeAd}
            >
              İlanı Tamamla
            </MazakaButton>


          )}


          {isPaid ? (
            <MazakaCard
              xs={24}
              lg={14}
              xxl={12}
              className="!border-none !rounded-tl-sm !rounded-tr-none !rounded-bl-sm !rounded-br-none !h-screen !flex justify-center !overflow-hidden  !w-full bg-gradient-to-t from-[#ffc600] to-yellow-300 opacity-95"
              bodyStyle={{ width: "100%" }}
            >
              <PackageInfoes />
            </MazakaCard>
          ) : (
            <></>
          )}


        </Row>
      </Col>

      {/* Ücretli ödeme için */}
      <Modal
        footer={false}
        open={isShowConfirmPaymentModal}
        onCancel={() => setisShowConfirmPaymentModal(false)}
      >
        <ConfirmPayment />
      </Modal>

      {/* Başarı modalı */}
      <Modal open={isShowSuccessPaymentModal} closable={false} footer={false}>
        <SuccessPayment
          setIsShowSuccessPaymentModal={setIsShowSuccessPaymentModal}
        />
      </Modal>
    </>
  );
};

export default Payment;
